import Home from "./pages/home";
import Boletas from "./pages/boletas";
import Retornos from "./pages/retornos";
import Cobros from "./pages/cobros";
import Basic from "layouts/authentication/sign-in";
import Cover from "layouts/authentication/sign-up";
import Ventas from "pages/ventas";
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "collapse",
    name: "Home",
    key: "home",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/",
    component: <Home />,
  },
  {
    type: "collapse",
    name: "Boletas",
    key: "boletas",
    icon: <Icon fontSize="small">receipt</Icon>,
    route: "/boletas",
    component: <Boletas />,
  },
  {
    type: "collapse",
    name: "Retornos",
    key: "retornos",
    icon: <Icon fontSize="small">redo</Icon>,
    route: "/retornos",
    component: <Retornos />,
  },
  {
    type: "collapse",
    name: "Cobros",
    key: "cobros",
    icon: <Icon fontSize="small">attach_money</Icon>,
    route: "/cobros",
    component: <Cobros />,
  },
  {
    type: "collapse",
    name: "Ventas",
    key: "ventas",
    icon: <Icon fontSize="small">shopping_cart</Icon>,
    route: "/ventas",
    component: <Ventas />,
  },
  {
    type: "hidden",
    name: "Iniciar sesión",
    key: "basic",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/signin",
    component: <Basic />,
  },
  {
    type: "collapse",
    name: "Editar perfil",
    key: "cover",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Cover />,
  },
];

export default routes;
